import { LoadingCircle } from '@alinta-digital/myaccount-frontend-shared';
import React from 'react';
import styled from 'styled-components';

const LoadingWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  flex-grow: 1;
  height: 500px;
  background-color: var(--background-color);
  padding-left: 16px;
  padding-right: 16px;
  gap: 18px;
`;

const ImgWrapper = styled.div`
  display: flex;
  width: 113px;
  height: 113px;
`;

export default function PaymentLoading(): JSX.Element {
  return (
    <LoadingWrapper data-testid="loadingUsage">
      <ImgWrapper data-testid="usageLoadingCircle">
        <LoadingCircle />
      </ImgWrapper>
    </LoadingWrapper>
  );
}
